import React from 'react'
import CustomPath from './CustomPath'

const OUTLINE_PATH = 'M56 0V56H0V0H56ZM12 44H44V12H12V44Z'
const RAW_WIDTH = 56
const RAW_HEIGHT = 56

/**
 * Square cutout shape component
 * @type {import('./CustomPath').CustomPath}
 */

export const SquareCutoutShape = React.forwardRef((props, ref) => {
    return <CustomPath {...props} ref={ref} data={OUTLINE_PATH} rawWidth={RAW_WIDTH} rawHeight={RAW_HEIGHT} />
})

export default SquareCutoutShape
